/**
 * url 相關工具方法
 */
import * as queryString from 'query-string';

export const deleteUrlQueryParam = (keys2Del: string[], url: string = window.location.href) => {
  // 不能變更排序；影響redirect_uri判斷
  const parsed = queryString.parseUrl(url, { sort: false });
  keys2Del.forEach(key => {
    delete parsed.query[key];
  });
  return queryString.stringifyUrl(parsed, { sort: false, encode: false });
};

export const addUrlQuery = (
  query2Add: queryString.StringifiableRecord,
  url: string = window.location.href
) => {
  const parsed = queryString.parseUrl(url, { sort: false });
  Object.assign(parsed, {
    query: {
      ...parsed.query,
      ...query2Add,
    },
  });
  return queryString.stringifyUrl(parsed, { sort: false, encode: false });
};

/**
 * 断言非数组，處理 query param 可能為數組的情況
 */
export const assertQuery = <T extends string>(param?: T[] | T | null) => {
  if (!Array.isArray(param)) {
    return param;
  }
  return param?.[0];
};

/**
 * 移除網址欄的 code 參數
 */
export const deleteUrlCode = () => {
  window.history.pushState(null, '', deleteUrlQueryParam(['code']));
};

/**
 * 移除網址欄指定參數
 */
export const deleteUrlParams = (code: string) => {
  window.history.pushState(null, '', deleteUrlQueryParam([code]));
};

/**
 * 關閉頁面（兼容模式）
 */
export const closePage = () => {
  if (
    navigator.userAgent.indexOf('Firefox') !== -1 ||
    navigator.userAgent.indexOf('Chrome') !== -1
  ) {
    window.location.href = 'about:blank';
    window.close();
  } else {
    window.opener = null;
    window.open('', '_self');
    window.close();
  }
};
